module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3612-68c86c1966cb3217edef2a24e41bb3d0.jpg";